import { useEffect } from "react";
import axios from "axios";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../data/seo";

// Injects sitewide Organization JSON-LD (shared layout), with sameAs
// populated from the currently verified social links in the admin.
export default function OrganizationSchema() {
  useEffect(() => {
    let script;
    const inject = (sameAs) => {
      document.head.querySelectorAll('script[data-org-schema]').forEach((el) => el.remove());
      const data = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: SITE_NAME,
        url: SITE_URL,
        logo: DEFAULT_OG_IMAGE,
      };
      if (sameAs.length) data.sameAs = sameAs;
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-org-schema", "true");
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
    };

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/social`)
      .then(({ data }) => inject(Array.isArray(data) ? data.map((s) => s.url) : []))
      .catch(() => inject([]));

    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);

  return null;
}
